/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbExportGapClassesGridDto } from './FcbExportGapClassesGridDto';
import {
    FcbExportGapClassesGridDtoFromJSON,
    FcbExportGapClassesGridDtoFromJSONTyped,
    FcbExportGapClassesGridDtoToJSON,
} from './FcbExportGapClassesGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbExportGapClassesGridDtoPaginatedResults
 */
export interface FcbExportGapClassesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbExportGapClassesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbExportGapClassesGridDto>}
     * @memberof FcbExportGapClassesGridDtoPaginatedResults
     */
    results?: Array<FcbExportGapClassesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbExportGapClassesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbExportGapClassesGridDtoPaginatedResults interface.
 */
export function instanceOfFcbExportGapClassesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbExportGapClassesGridDtoPaginatedResultsFromJSON(json: any): FcbExportGapClassesGridDtoPaginatedResults {
    return FcbExportGapClassesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbExportGapClassesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbExportGapClassesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbExportGapClassesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbExportGapClassesGridDtoPaginatedResultsToJSON(value?: FcbExportGapClassesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbExportGapClassesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

